export default __webpack_public_path__ + "static/media/itwlogo.95208a47.png";